import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { IWidgetProperty } from '../interfaces/IWidgetProperty';
import { IWidgetDefinition } from './../interfaces/IWidgetDefinition';

const widgetDefinitions = require('../../../../resources/json/widgetdefinitions.json');

@Injectable()
export class InteractivityWidgetDefinitionService {

	private _widgetDefinitions: IWidgetDefinition[];
	private _widgetDefinitionsSubject: ReplaySubject<IWidgetDefinition[]>;

	private typesByKey: any = {};
	private itypesByKey: any = {};

	private widgetDefaultsByType: any = {};

	constructor() {
		this._widgetDefinitions = [];
		this._widgetDefinitionsSubject = new ReplaySubject<IWidgetDefinition[]>();
		this.parseWidgetDefinitions();
	}

	public parseWidgetDefinitions() {
		this._widgetDefinitions = widgetDefinitions;

		this.widgetDefaultsByType = {};
		for (let i = 0, il = this._widgetDefinitions.length; i < il; i++) {
			const def: IWidgetDefinition = this._widgetDefinitions[i];
			const def_props: any[] = def.configProperties;

			if (def_props) {
				for (let j = 0, jl = def_props.length; j < jl; j++) {
					const def_prop: any = def_props[j];

					if (def_prop.type) {
						this.typesByKey[def_prop.name] = def_prop.type;
					}
					if (def_prop.itype) {
						this.itypesByKey[def_prop.name] = def_prop.itype;
					}
				}
			}

			const def_fields = def.configFields;
			for (const key in def_fields) {
				if (def_fields.hasOwnProperty(key)) {
					if (!this.widgetDefaultsByType[def.widgetDefinitionType]) {
						this.widgetDefaultsByType[def.widgetDefinitionType] = {};
					}
					this.widgetDefaultsByType[def.widgetDefinitionType][key] = def_fields[key];
				}
			}
		}

		this._widgetDefinitionsSubject.next(this._widgetDefinitions);
	}

	get widgetDefinitionsSubject(): ReplaySubject<IWidgetDefinition[]> {
		return this._widgetDefinitionsSubject;
	}

	getWidgetPropertyFromConfig(key: string, value: string): IWidgetProperty {
		const type: string = this.typesByKey[key];
		const itype: string = this.itypesByKey[key];
		return { key, value, type, itype };
	}

	getWidgetDefaultsForType(type: string) {
		return this.widgetDefaultsByType[type];
	}
}
